import { Rss } from 'lucide-react'

import { PluginDefinition } from '@/types/plugin'

import CatalogueFeedPage from './CatalogueFeedPage'
import { CATALOGUE_FEED_PLUGIN_ID } from './constants'

export const CatalogueFeedPlugin: PluginDefinition = {
  id: CATALOGUE_FEED_PLUGIN_ID,
  name: 'Product catalogue feed',
  description:
    'Keep your products in sync with Facebook, Instagram and Google Shopping. Powers Instagram and Facebook Shops, catalogue ads and free Google listings.',
  version: '1.0.0',
  author: 'IWS Commerce',
  routes: [{ path: 'catalogue-feed', element: <CatalogueFeedPage /> }],
  navItems: [{ label: 'Catalogue feed', path: '/catalogue-feed', icon: Rss }],
}
